<div
  id="message-wrapper-main"
  class="message-wrapper"
  [ngClass]="{
    RTLDir: isRTL,
    alertModel: participation_Message_Type == 52,
    'page-preview-all-hdn': participation_Message_Type == 14,
    'message-padding':
      participation_Message_Type == 5 ||
      participation_Message_Type == 51 ||
      participation_Message_Type == 52,
    'cookie-wrapper': participation_Message_Type == 4,
    partialComplete:
      participation_Message_Type == 3 ||
      participation_Message_Type == 6 ||
      participation_Message_Type == 7,
    'browser-support-wrapper': participation_Message_Type == 20 || participation_Message_Type == 21
  }"
>
  <div
    *ngIf="
      isSubscriptionModel &&
      (participation_Message_Type == 5 ||
        participation_Message_Type == 51 ||
        participation_Message_Type == 52)
    "
  >
    <div
      *ngIf="!participation_Messages.isShowSubscription"
      [ngClass]="{ 'message-header-wrapper': !isMobile }"
    >
      <div *ngIf="!isMobile" class="message-icon browser-message"></div>
      <div class="message-heading-text">
        <div [innerHTML]="participation_Messages.Error_Header | headerFooterHtml"></div>
      </div>
    </div>
    <div *ngIf="isMobile" class="mobile-message-icon"></div>
    <div class="message-info-wrapper image-width sogo">
      <div
        class="message-text"
        [ngStyle]="{ 'text-align': isMobile ? 'center' : !isMobile && isRTL ? 'Right' : 'left' }"
      >
        <div [innerHTML]="participation_Messages.Error_Message | headerFooterHtml"></div>
      </div>
      <div *ngIf="participation_Messages.isShowSubscription" class="sogo-logo-wrapper">
        <img
          src="{{ path }}/ProductImages/Product_specifics/logo.png"
          alt="Sogolytics"
          title="Sogolytics"
        />
        <div class="sogo-info">The Fastest-Growing Online Survey Software Company</div>
      </div>
      <div *ngIf="participation_Messages.isShowSubscription" class="sogo-signup-wrapper">
        <h2 class="signup-title">Reach out with a whole, new survey experience.</h2>
        <a href="static/Packages.aspx" class="signup-button">Sign Up Free</a>
      </div>
      <div *ngIf="participation_Messages.isShowSubscription" class="sogo-footer-wrapper">
        <div class="sogo-poweredby">Powered by <a href="">Sogolytics</a></div>
        <div class="sogo-sample-surveys">
          Check out our <a href="sample-surveys.aspx">sample surveys</a>
        </div>
      </div>
    </div>
  </div>

  <!-- Message -->
  <div *ngIf="participation_Message_Type == 2">
    <div [ngClass]="{ 'message-header-wrapper': !isMobile }">
      <div
        *ngIf="!isMobile"
        class="message-icon"
        [ngClass]="
          participation_Messages.partial_and_quota_message.isQuota
            ? 'quota-saved-icon'
            : 'partial-data-saved-icon'
        "
      ></div>
      <div
        [ngClass]="
          participation_Messages.partial_and_quota_message.isQuota
            ? 'quota-message-heading-text'
            : 'message-heading-text'
        "
      >
        <div
          [innerHTML]="
            participation_Messages.partial_and_quota_message.partial_header | headerFooterHtml
          "
        ></div>
      </div>
    </div>
    <div
      class="message-info-wrapper image-width sogo"
      [ngClass]="{ 'quota-wrapper': participation_Messages.partial_and_quota_message.isQuota }"
    >
      <div
        class="message-text"
        *ngIf="isPartialAccessHide"
        [ngClass]="{ 'message-text-mobile': isMobile }"
      >
        <div
          [innerHTML]="
            participation_Messages.partial_and_quota_message.partial_message1 | headerFooterHtml
          "
        ></div>
      </div>

      <div
        class="message-text"
        *ngIf="isPartialAccessDoneHide"
        [ngClass]="{ 'message-text-mobile': !isPreview && isMobile }"
      >
        <div
          [innerHTML]="
            participation_Messages.partial_and_quota_message.PartialMessagePublicAccessDone
              | headerFooterHtml
          "
        ></div>
      </div>

      <div class="url-info" *ngIf="participation_Messages?.partial_and_quota_message.unique_url">
        <a href="{{ unique_url }}" [attr.target]="isEmbedMobile ? '_self' : '_blank'">{{
          participation_Messages?.partial_and_quota_message.unique_url1
        }}</a>
        <span class="copy_link_pm" title="Copy" (click)="copyToClipboard()"></span>
      </div>
      <div
        class="message-text"
        *ngIf="isPartialAccessHide && !islinkemail"
        [ngClass]="{ 'message-text-mobile': !isPreview && isMobile }"
      >
        <div
          [innerHTML]="
            (participation_Messages.partial_and_quota_message?.partial_message2
              ? participation_Messages.partial_and_quota_message?.partial_message2
              : ''
            ) | headerFooterHtml
          "
        ></div>
      </div>
      <div
        *ngIf="
          participation_Messages.partial_and_quota_message.button_text &&
          isPartialAccessHide &&
          !islinkemail
        "
        class="send-container"
      >
        <input
          *ngIf="!participation_Messages.partial_and_quota_message.isQuota"
          [(ngModel)]="email_id"
          type="text"
          (blur)="emailValidation($event.target.value)"
          class="send-email-text"
          placeholder="Email address"
        />
        <span
          (click)="linkemail($event)"
          name="goBackQuota"
          *ngIf="!participation_Messages.partial_and_quota_message.isQuota"
          class="send_email_pm_new"
          [attr.title]="participation_Messages.partial_and_quota_message.button_text"
        ></span>
        <!-- PRT 102783 -->
        <input
          *ngIf="participation_Messages.partial_and_quota_message.isQuota"
          type="button"
          value="{{ participation_Messages.partial_and_quota_message.button_text }}"
          (click)="linkemail($event)"
          name="goBackQuota"
          [ngClass]="
            participation_Messages.partial_and_quota_message.isQuota
              ? 'send-email-submit quota-button'
              : 'send_email_pm_new'
          "
        />
      </div>
      <div
        *ngIf="
          participation_Messages.partial_and_quota_message.button_text &&
          isPartialAccessHide &&
          islinkemail
        "
        class="email-done-container-wrapper"
      >
        <div class="email-done-parent">
          <div class="email-done-container">
            <div class="email-done-icon-parent"><span class="new_done_icon_pm"></span></div>

            <span class="link-emailed-text"
              >Link emailed to
              <a class="link-email-id" href="mailto:{{ email_id }}">{{ email_id }}</a></span
            >
          </div>
        </div>
      </div>
      <div
        class="message-text switch-project-type newNoteContent NoteComponent"
        *ngIf="isPartialAccessHide && isPartialMessage3Visible"
        [ngClass]="{ 'message-text-mobile': !isPreview && isMobile }"
      >
        <div
          [innerHTML]="
            (participation_Messages.partial_and_quota_message?.partial_message3
              ? participation_Messages.partial_and_quota_message?.partial_message3
              : ''
            ) | headerFooterHtml
          "
        ></div>
      </div>
      <div
        class="clsThankYou"
        [ngStyle]="{ 'padding-bottom': isMobile ? '40px' : '' }"
        *ngIf="participation_Messages.partial_and_quota_message.PrintResponseOnSaveCon"
        [innerHTML]="
          participation_Messages.partial_and_quota_message.PrintResponseOnSaveCon | headerFooterHtml
        "
      ></div>
    </div>
  </div>

  <!-- Drop Out Message -->
  <div
    *ngIf="
      participation_Message_Type == 3 ||
      participation_Message_Type == 6 ||
      participation_Message_Type == 7
    "
    [ngClass]="{ 'message-Drop-Out': !isSubscriptionModel }"
  >
    <div [ngClass]="{ 'message-header-wrapper': !isMobile }">
      <div *ngIf="!isMobile" class="message-icon partial-data-saved-icon"></div>
      <div class="message-heading-text">
        <div
          [innerHTML]="
            participation_Messages.partial_url_message.partially_header | headerFooterHtml
          "
        ></div>
      </div>
    </div>
    <div class="message-info-wrapper image-width sogo">
      <div [ngClass]="isMobile ? 'message-text-mobile' : 'message-text'">
        <div
          [innerHTML]="
            participation_Messages.partial_url_message.partially_message | headerFooterHtml
          "
        ></div>
      </div>

      <div class="resume-survey-wrapper" *ngIf="participation_Message_Type == 3">
        <div class="modelresponseBtns">
          <div
            class="responseInfo"
            *ngIf="participation_Messages.partial_url_message.partially_last_info"
          >
            <span
              class="tooltiptext"
              [innerText]="participation_Messages.partial_url_message.partially_last_info"
            ></span>
          </div>
          <div class="responseIcon leftOver"></div>
          <div class="modelresponseTxt" name="LastLeftResponse" (click)="LastLeftResponse($event)">
            {{ participation_Messages.partial_url_message.partially_last }}
          </div>
        </div>
        <div class="modelresponseBtns">
          <div
            class="responseInfo"
            *ngIf="participation_Messages.partial_url_message.partially_begin_info"
          >
            <span
              class="tooltiptext"
              [innerText]="participation_Messages.partial_url_message.partially_begin_info"
            ></span>
          </div>
          <div class="responseIcon Start"></div>
          <div class="modelresponseTxt" name="BeginNewResponse" (click)="BeginNewResponse($event)">
            {{ participation_Messages.partial_url_message.partially_begin }}
          </div>
        </div>
      </div>

      <div class="resume-survey-wrapper" *ngIf="participation_Message_Type == 7">
        <div class="modelresponseBtns">
          <div
            class="responseInfo"
            *ngIf="participation_Messages.partial_url_message.partially_last_info"
          >
            <span
              class="tooltiptext"
              [innerText]="participation_Messages.partial_url_message.partially_last_info"
            ></span>
          </div>
          <div class="responseIcon leftOver"></div>
          <div class="modelresponseTxt" name="LastLeftResponse" (click)="LastLeftResponse($event)">
            {{ participation_Messages.partial_url_message.partially_last }}
          </div>
        </div>
        <div class="modelresponseBtns">
          <div
            class="responseInfo"
            *ngIf="participation_Messages.partial_url_message.partially_begin_info"
          >
            <span
              class="tooltiptext"
              [innerText]="participation_Messages.partial_url_message.partially_begin_info"
            ></span>
          </div>
          <div class="responseIcon Start"></div>
          <div
            class="modelresponseTxt"
            name="BeginNewResponseRef"
            (click)="BeginNewResponseRef($event)"
          >
            {{ participation_Messages.partial_url_message.partially_begin }}
          </div>
        </div>
      </div>

      <div class="resume-survey-wrapper" *ngIf="participation_Message_Type == 6">
        <div class="modelresponseBtns">
          <div
            class="responseInfo"
            *ngIf="participation_Messages?.partial_url_message.partially_begin_info"
          >
            <span
              class="tooltiptext"
              [innerText]="participation_Messages?.partial_url_message.partially_begin_info"
            ></span>
          </div>
          <div class="responseIcon Start"></div>
          <div
            class="modelresponseTxt"
            style="display: inline-block"
            name="SurveyEdiited"
            (click)="SurveyEdiited($event)"
          >
            {{ participation_Messages.partial_url_message?.partially_begin }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Cookies Message -->
  <div *ngIf="participation_Message_Type == 4">
    <div [ngClass]="{ 'message-header-wrapper': !isMobile }">
      <div *ngIf="!isMobile && !isTechCheck" class="message-icon partial-data-saved-icon"></div>
      <div
        *ngIf="!isMobile && isTechCheck"
        class="mobile-message-icon"
        style="background-size: 99% !important; height: 70px; min-width: 75px"
      ></div>
      <div *ngIf="!isTechCheck" class="message-heading-text">Cookies are Disabled</div>
      <div *ngIf="isTechCheck" class="message-heading-text">Tech Check</div>
      <div
        *ngIf="isMobile"
        class="cookie-icon mobile-message-icon"
        style="background-size: 38%; height: 120px"
      ></div>
    </div>
    <div class="message-info-wrapper image-width sogo">
      <div *ngIf="!isTechCheck" class="message-text">
        <div *ngIf="!isMobile && !isTablet" class="subhead" runat="server">
          Greetings!<br />
          <br />
          It appears that your current browser settings are preventing you from opening this link.
          To participate, please enable cookies.
          <br />
          <br />
          Select your browser for detailed instructions.
        </div>
        <div *ngIf="isMobile || isTablet" class="subhead" runat="server">
          Greetings!<br />
          <br />
          It appears that your current browser settings are preventing you from opening this link.
          To participate, please enable cookies. Select your browser for detailed instructions.
        </div>
        <div>
          <div class="cookie-browser-cont">
            <a
              target="blank"
              href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&amp;hl=en&amp;oco=1"
              class="browser_icons_names"
            >
              <a _ngcontent-wof-c73="" class="cookie-browser chrome"></a>
              <div class="browser_name">Google Chrome</div>
            </a>
            <a
              class="browser_icons_names"
              target="blank"
              href="https://support.mozilla.org/en-US/kb/websites-say-cookies-are-blocked-unblock-them"
            >
              <a _ngcontent-wof-c73="" class="cookie-browser firefox"></a>
              <div class="browser_name">Firefox</div>
            </a>
            <a
              class="browser_icons_names"
              target="blank"
              href="https://answers.microsoft.com/en-us/windows/forum/apps_windows_10-msedge/edge-how-do-i-enable-cookies/275b58e3-d741-4b21-8042-3059b1902d0e"
            >
              <a _ngcontent-wof-c73="" class="cookie-browser edge"></a>
              <div class="browser_name">Microsoft Edge</div>
            </a>
            <a
              class="browser_icons_names"
              target="blank"
              href="https://support.apple.com/en-in/guide/safari/sfri11471/mac"
            >
              <a _ngcontent-wof-c73="" class="cookie-browser safari"></a>
              <div class="browser_name">Safari</div>
            </a>
            <a
              *ngIf="!isMobile && !isTablet"
              class="browser_icons_names"
              target="blank"
              href="https://support.microsoft.com/en-in/help/17442/windows-internet-explorer-delete-manage-cookies"
            >
              <a _ngcontent-wof-c73="" class="cookie-browser ie"></a>
              <div class="browser_name">Internet Explorer</div>
            </a>

            <div id="divclr1" class="clr"></div>
          </div>
        </div>
        <div class="cookie-browser-link" *ngIf="ProductName === 'sogo' || ProductName === 'zarca'">
          <a target="blank" href="https://www.sogolytics.com/blog/cookie-policy/"
            >Sogolytics Cookie Policy</a
          >
        </div>
      </div>
      <div *ngIf="isTechCheck" class="message-text">
        Unfortunately, it looks like your browser doesn't want to open this. To participate in a new
        tab, <a href="{{ SurveyURL }}" target="_blank">click here</a>
      </div>
    </div>
  </div>

  <!-- Check Survey - 5 and Already Participated - 51-->
  <div
    *ngIf="
      !isSubscriptionModel &&
      (participation_Message_Type == 5 ||
        participation_Message_Type == 51 ||
        participation_Message_Type == 52)
    "
  >
    <div [ngClass]="{ 'message-header-wrapper': !isMobile }">
      <div *ngIf="!isMobile" class="message-icon browser-message"></div>
      <div class="message-heading-text">
        <div [innerHTML]="participation_Messages.Error_Header | headerFooterHtml"></div>
      </div>
    </div>
    <div *ngIf="isMobile" class="mobile-message-icon"></div>
    <div class="message-info-wrapper image-width sogo">
      <div class="message-text" [ngStyle]="{ 'text-align': isMobile ? 'center' : 'justify' }">
        <div class="message-text">
          <div [innerHTML]="participation_Messages.Error_Message | headerFooterHtml"></div>
        </div>
      </div>
      <br />
    </div>
  </div>

  <!-- Page Preview Hidden Message - 14 -->
  <div *ngIf="participation_Message_Type == 14">
    <div [ngClass]="{ 'message-header-wrapper': !isMobile }">
      <div *ngIf="!isMobile" class="message-icon browser-message"></div>
      <div class="message-heading-text">
        <div [innerHTML]="participation_Messages.Error_Header | headerFooterHtml"></div>
      </div>
    </div>
    <div *ngIf="isMobile" class="mobile-message-icon"></div>
    <div class="message-info-wrapper image-width sogo">
      <div class="message-text" [ngStyle]="{ 'text-align': isMobile ? 'center' : 'justify' }">
        <div class="message-text">
          <div [innerHTML]="participation_Messages.Error_Message | headerFooterHtml"></div>
        </div>
      </div>
      <br />
    </div>
  </div>

  <!-- Browser Supported Message - 20 - 21 -->
  <div *ngIf="participation_Message_Type == 20 || participation_Message_Type == 21">
    <div [ngClass]="{ 'message-header-wrapper': !isMobile }">
      <div *ngIf="!isMobile" class="message-icon browser-message"></div>
      <div class="message-heading-text" *ngIf="participation_Message_Type == 20">
        <div>This browser is partially supported!</div>
      </div>
      <div class="message-heading-text" *ngIf="participation_Message_Type == 21">
        <div>This browser is not supported!</div>
      </div>
    </div>
    <div *ngIf="isMobile" class="mobile-message-icon"></div>
    <div class="message-info-wrapper image-width sogo">
      <div class="message-text" [ngStyle]="{ 'text-align': isMobile ? 'center' : 'justify' }">
        <div class="message-text">
          <div *ngIf="!isMobile" class="subhead" runat="server">
            Dear {{ surveyType }} participant,<br />
            <br />
            You appear to be using a Web Browser that is not supported by us.
            <br />
            A list of browsers supported is shown below. You can download any of these by clicking
            on the browser&rsquo;s name. Once you have downloaded it, you can install by simply
            following the instructions.
          </div>
          <div *ngIf="isMobile" class="subhead" runat="server">
            Dear {{ surveyType }} participant,<br />
            <br />
            You appear to be using a Web Browser that is not supported by us.
            <br />A list of browser(s) supported is shown below. In order to participate in the
            please install/update any of the listed browser and try again.
          </div>
          <div *ngIf="!isMobile">
            <div class="browser_not_support">
              <a
                *ngIf="!isMobile && !isTablet"
                class="browser_icons_names"
                target="blank"
                href="https://www.microsoft.com/en-us/download/internet-explorer.aspx"
              >
                <a _ngcontent-wof-c73="" class="cookie-browser ie"></a>
                <div class="browser_name">Internet Explorer Version 11.0 +</div>
              </a>
              <a
                class="browser_icons_names"
                target="blank"
                href="http://www.mozilla.com/en-US/firefox/"
              >
                <a _ngcontent-wof-c73="" class="cookie-browser firefox"></a>
                <div class="browser_name">Mozilla Firefox Version 4.0 +</div>
              </a>
              <a
                class="browser_icons_names"
                target="blank"
                href="http://www.apple.com/safari/download/"
              >
                <a _ngcontent-wof-c73="" class="cookie-browser safari"></a>
                <div class="browser_name">
                  Safari<br />
                  Version 5.0 +
                </div>
              </a>

              <a
                class="browser_icons_names"
                target="blank"
                href="http://www.google.com/chrome/index.html"
              >
                <a _ngcontent-wof-c73="" class="cookie-browser chrome"></a>
                <div class="browser_name">Google Chrome Version 7.0 +</div>
              </a>
              <a
                class="browser_icons_names"
                target="blank"
                href="http://downloads.channel.aol.com/windowsproducts"
              >
                <a _ngcontent-wof-c73="" class="cookie-browser aol"></a>
                <div class="browser_name">AOL<br />Version 9.0 +</div>
              </a>
              <a
                class="browser_icons_names"
                target="blank"
                href="https://www.microsoft.com/en-us/edge?r=1"
              >
                <a _ngcontent-wof-c73="" class="cookie-browser edge"></a>
                <div class="browser_name">
                  IE Edge<br />
                  Version 12.0 +
                </div>
              </a>

              <div id="divclr1" class="clr"></div>
            </div>
          </div>
          <div *ngIf="isMobile">
            <a
              class="browser_icons_names"
              target="blank"
              href="https://support.apple.com/en-in/guide/safari/sfri11471/mac"
            >
              <a _ngcontent-wof-c73="" class="cookie-browser safari"></a>
              <div class="browser_name">Safari</div>
            </a>
            <div class="IEcont">
              <div class="Androideimg"></div>
              <div class="IEtxt">
                <a href="https://www.microsoft.com/en-us/download/details.aspx?id=48126"
                  >IE Edge<br />
                  Android Browser (Version 2.2 and above)</a
                >
              </div>
            </div>

            <div class="IEcont">
              <div class="BBimg"></div>
              <div class="IEtxt">
                <a href="https://www.microsoft.com/en-us/download/details.aspx?id=48126"
                  >IE Edge<br />
                  Android Browser (Version 2.2 and above)</a
                >
              </div>
            </div>
          </div>
          <p class="subhead" *ngIf="participation_Message_Type == 20">
            If you choose not to install any of these browsers, you may still continue with your
            current browser. However, we cannot guarantee that all the features will work properly.
            We encourage you to complete this {{ surveyType }} using one of the browsers listed
            above.
          </p>
          <div
            class="surveybtn"
            style="padding-bottom: 20px"
            *ngIf="participation_Message_Type == 20"
          >
            <input
              class="send-email-submit contsurvey"
              type="button"
              value="CONTINUE TO {{ surveyType | uppercase }}"
              name="BrowserContinue"
              (click)="BrowserContinue($event)"
            />
          </div>
        </div>
      </div>
      <br />
    </div>
  </div>

  <ng-template #WithoutSogoFooter>
    <div [ngClass]="{ 'message-header-wrapper': !isMobile }">
      <div *ngIf="!isMobile" class="message-icon already-participated"></div>
      <div class="message-heading-text">
        <div [innerHTML]="participation_Messages.Error_Header | headerFooterHtml"></div>
      </div>
    </div>
    <div *ngIf="isMobile" class="mobile-message-icon"></div>
    <div class="message-info-wrapper image-width sogo">
      <div class="message-text">
        <div [innerHTML]="participation_Messages.Error_Message | headerFooterHtml"></div>
      </div>

      <div class="resume-survey-wrapper" *ngIf="participation_Message_Type == 2">
        <a href="" class="resume-link"
          >Click here to start at the beginning of the {{ surveyType }}</a
        >
        <a href="" class="resume-link">Click here to return where you last left off</a>
      </div>
      <div class="view-responses-wrapper" *ngIf="participation_Message_Type == 2">
        <a href="">
          <div class="view-response">
            <img
              alt="View Responses"
              src="{{ path }}/imagesNew/PM/Print_Responses_icon.png"
              width="60"
            />
            <p title="View Responses" class="">View Responses</p>
          </div>
        </a>
      </div>
    </div>
  </ng-template>
</div>
